import { Avatar as MUIAvatar } from "@mui/material";
import Stack from "@mui/material/Stack";
import { useEffect, useState } from "react";

interface AvatarProps {
  name: string;
  photoPath?: string;
}
const getInitials = (fullName: string) => {
  if (!fullName) {
    return;
  }

  const words = fullName?.trim().split(" ");
  return words.length > 1
    ? `${words[0][0]}${words[1][0]}`.toUpperCase()
    : words[0][0].toUpperCase();
};

export const Avatar = ({ name, photoPath: initialPhotoPath }: AvatarProps) => {
  const [userData, setUserData] = useState<{
    name: string;
    photoPath?: string;
  }>({
    name,
    photoPath: initialPhotoPath,
  });

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const data = event.data;
      if (!data || typeof data !== "object") return;
      if (data.type !== "UPDATE_PROFILE") return;

      setUserData({
        name: data.payload.name || name,
        photoPath: data.payload.photoPath || initialPhotoPath,
      });
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [name, initialPhotoPath]);

  const avatarContent = userData?.photoPath ? (
    <img
      src={`data:image/jpeg;base64,${userData.photoPath}`}
      alt={userData.name}
      width={25}
    />
  ) : (
    getInitials(userData.name)
  );

  return (
    <Stack direction="row" spacing={2}>
      <button className="br-sign-in primary">
        <MUIAvatar className={"xvia-header-user-avatar-label"}>
          {avatarContent}
        </MUIAvatar>
        <span className={"xvia-header-user-avatar-text"}>
          Olá, {name.split(" ")[0]}
        </span>
      </button>
    </Stack>
  );
};
